import { render } from "./ElementsListing.vue?vue&type=template&id=208bfe26&scoped=true"
import script from "./ElementsListing.vue?vue&type=script&lang=js"
export * from "./ElementsListing.vue?vue&type=script&lang=js"

import "./ElementsListing.vue?vue&type=style&index=0&id=208bfe26&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208bfe26"]])

export default __exports__